import { OrderTemplate } from 'common/interface';
import React from 'react';

import type { FC } from 'react';
import 'app/pages/hosted-checkout/components/AdditionalChargesSection/styles.scss';

export const ChargeRow: FC<ChargeRowProps> = ({ chargeName, value }) => (
  <div className='charge-row' data-testid={chargeName}>
    <p>{chargeName}</p>
    <p>{value}</p>
  </div>
);

const AdditionalChargesSection: FC<AdditionalChargesSectionProps> = ({
  parseCurrencyFunction,
  orderTemplate,
  labels,
}) => {
  const subtotal =
    orderTemplate.subtotal ??
    orderTemplate.lineItems.reduce((prev: any, current: any) => prev + current.unitPrice * current.quantity, 0);
  return (
    <div className='additional-charges'>
      <ChargeRow chargeName={labels.subtotal} value={parseCurrencyFunction(subtotal)} />
      {orderTemplate.shippingLines.map(({ amount }, index) => (
        <ChargeRow key={`shipping-${index}`} chargeName={labels.shipping} value={parseCurrencyFunction(amount)} />
      ))}
      {orderTemplate.taxLines.map(({ description, amount }, index) => (
        <ChargeRow
          key={`tax-${index}`}
          chargeName={description === 'Shipping tax' ? labels.tax : description}
          value={parseCurrencyFunction(amount)}
        />
      ))}
      {orderTemplate.discountLines.map(({ code, amount }, index) => (
        <ChargeRow key={`discount-${index}`} chargeName={code} value={`- ${parseCurrencyFunction(amount)}`} />
      ))}
    </div>
  );
};

interface ChargeRowProps {
  chargeName: string;
  value: string;
}

interface AdditionalChargesSectionProps {
  parseCurrencyFunction: Function;
  orderTemplate: OrderTemplate;
  labels: {
    subtotal: string;
    shipping: string;
    tax: string;
    discount: string;
  };
}

export default React.memo(AdditionalChargesSection);
